import { Button, Col, Form, Row } from "react-bootstrap"
import { FeedbackButton, IMG } from "../../Commons/Functions"

export default function Preferences_Profile({ updateProfileField, ...props }) {
    return (
        <div className="d-flex flex-column">
            <Form.Group className="d-flex flex-column box-container">
                <h5 className="text-start">Username</h5>
                <div className="d-flex">
                    <Form.Control
                        type="text"
                        id="profile-username"
                        className='w-75'
                        defaultValue={props.profileData.name}
                    />
                    <FeedbackButton className="w-25" onClick={() => {
                        let val = document.getElementById("profile-username").value
                        updateProfileField("name", val)
                    }} feedBack="Changed !">Change</FeedbackButton>
                </div>
            </Form.Group>

            <Form.Group className="d-flex flex-column box-container">
                <div className="d-flex justify-content-between mb-2 ms-0">
                    <div className="d-flex flex-column text-start">
                        <h5>Avatar</h5>
                        <p className="ms-2 me-4">Your avatar will be displayed next to your counters. For a better look, try to find a squared image.</p>
                    </div>
                    {props.profileData.avatar == "" ?
                        (
                            <p style={{ width: "10vh", height: "10vh" }}>No avatar</p>
                        ) :
                        (
                            <div className="position-relative"><IMG style={{ width: "10vh", height: "10vh", objectFit: "cover", borderRadius: "var(--bs-border-radius)" }} src={props.profileData.avatar} /></div>
                        )}
                </div>



                <div className="d-flex">
                    <Form.Control
                        type="text"
                        id="profile-image"
                        className='w-75'
                        defaultValue={props.profileData.avatar}
                    />
                    <FeedbackButton className="w-25" onClick={() => {
                        let val = document.getElementById("profile-image").value
                        updateProfileField("avatar", val)
                    }} feedBack="Changed !">Change</FeedbackButton>
                </div>
            </Form.Group>

        </div>
    )
}

function Option({ title, ...props }) {
    return (
        <Form.Group as={Row} className="mb-0 w-100 ps-2">
            <Form.Label column>
                {title}
            </Form.Label>
            <Col className="d-flex justify-content-start align-items-center" sm={3}>
                {props.children}
            </Col>
        </Form.Group>
    )
}